
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListOption } from '@/interfaces/registration/ListOption';
import { namespace } from 'vuex-class';
const utils = namespace('utils');

@Component
export default class AvatarPicker extends Vue {
  @Prop() readonly value!: string;

  @utils.State
  public userAvatars!: Array<ListOption>;

  public selectAvatar (userAvatar: ListOption): void {
    this.$emit('input', userAvatar.value);
  }

  public isUserAvatarSelected (userAvatar: ListOption): boolean {
    return this.value === userAvatar.value;
  }
}
